import React from 'react';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import CoachingAvatar from 'assets/images/coaching/coaching_avatar.svg';

import './styles/CoachingViewHeader.scss';

type Props = {
  title: string;
  showHelpButton?: boolean;
};

export default function CoachingViewHeader({ title, showHelpButton }: Props) {
  return (
    <div className="CoachingViewHeader">
      <MediaObject figure="right" className="CoachingViewHeader-top">
        <div className="CoachingViewHeader-left">
          <div className="CoachingViewHeader-left-group">
            <MediaObject center gutter="small">
              <Image width={40} src={CoachingAvatar} />
              <div>
                <Text size="large" element="div" truncate weight="semibold">
                  {title}
                </Text>
              </div>
            </MediaObject>
          </div>
        </div>
        <div className="CoachingViewHeader-right">
          {showHelpButton && (
            <Buttons>
              <Button level="secondary" color="eclipse">
                Get help
              </Button>
            </Buttons>
          )}
        </div>
      </MediaObject>
    </div>
  );
}
